import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { Plus } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize, noop } from '@fabric-ui/utils';
import { Box, Button } from '@mui/material';

export interface AddOperandButtonProps {
  operator: 'and' | 'or';
  onClick?: () => void;
  isAdd?: boolean;
  disabled?: boolean;
  hideText?: boolean;
  style?: any;
  size?: 'xSmall' | 'small';
  disableMessage?: string;
}

export const AddOperandButton: React.FC<AddOperandButtonProps> = ({
  operator,
  onClick = noop,
  isAdd = false,
  disabled = false,
  style,
  hideText = false,
  size = 'small',
  disableMessage = undefined,
}) => {
  const button = (
    <Button
      onClick={onClick}
      disabled={disabled}
      disableElevation
      sx={{
        ...styles(operator),
        borderRadius: size === 'xSmall' ? '8px' : '10px',
        ...(size !== 'xSmall' && { p: '2px 8px' }),
        ...style,
        ...(hideText && isAdd && { p: '3px' }),
      }}>
      {isAdd ? <Plus style={{ ...iconSize(16) }} /> : undefined}
      {!hideText ? <Box sx={{ fontSize: size === 'xSmall' ? 11 : 12 }}>{operator.toUpperCase()}</Box> : undefined}
    </Button>
  );
  return disableMessage ? (
    <AvTooltip title={disableMessage} variant="message" color="white">
      <div>{button}</div>
    </AvTooltip>
  ) : (
    button
  );
};

const styles = (operator: 'and' | 'or') => ({
  ...flex.center,
  alignSelf: 'center',
  gap: '4px',
  lineHeight: '18px',
  cursor: 'pointer',
  px: 1,
  backgroundColor: 'var(--color-surface-base-primary)',
  border: '1px solid var(--color-border-interactive-secondary-default)',
  fontWeight: 600,
  color: operatorColors[operator],
  '&:hover': {
    backgroundColor: 'var(--color-surface-base-secondary)',
    borderColor: 'var(--color-border-interactive-secondary-hover)',
    color: operatorColors[operator],
  },
  '&.Mui-disabled': {
    backgroundColor: 'var(--color-surface-interactive-secondary-disabled)',
    borderColor: 'transparent',
    color: 'var(--color-content-interactive-secondary-disabled)',
  },
});

export const operatorColors = {
  and: 'var(--color-content-interactive-primary-default)',
  or: 'var(--color-content-status-warning-secondary)',
};
